import {
  SnippetElement,
  Theme,
  defineElement,
  globalOn,
  param
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/snippets/util-cart-value/util-cart-value.ts
var UtilCartValue = class extends SnippetElement {
  connectedCallback() {
    Theme.Cart.on("updated", () => this.render());
  }
  render() {
    return __async(this, null, function* () {
      var _a;
      const cart = yield Theme.Cart.fetch();
      const path = (_a = this.key) == null ? void 0 : _a.split(".");
      if (path) {
        let value = cart;
        for (const key of path) {
          value = value == null ? void 0 : value[key];
        }
        this.innerText = value;
      }
    });
  }
};
__decorateClass([
  param()
], UtilCartValue.prototype, "key", 2);
__decorateClass([
  globalOn("cart:updated")
], UtilCartValue.prototype, "render", 1);
UtilCartValue = __decorateClass([
  defineElement("util-cart-value")
], UtilCartValue);
export {
  UtilCartValue
};
